import React from 'react';
import { Button, Alert } from '@mui/material';
import CommonDialog from "../CommonDialog/CommonDialog";

const LibraryWarnMessage = ({ open, onClose }) => {
    return (
        <CommonDialog open={open} onClose={onClose} title="Preserved Library Name">
            <Alert severity="warning" className="unsaved-alert">
                The name you have entered is an app defined library name. You cannot create a library with this name.
            </Alert>
                <Button onClick={onClose} variant="contained" color="primary">
                    OK
                </Button>
        </CommonDialog>
    );
};

export default LibraryWarnMessage;
